import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      width: '100%',
      marginTop: theme.spacing(1),
    },
    lineChartComponent: {
      marginTop: theme.spacing(2),
    },
    lineChart: {
      display: 'flex',
      width: '100%',
      height: theme.spacing(0.75),
      borderRadius: theme.spacing(0.5),
      overflow: 'hidden',
    },
    legendsWrapper: {
      marginTop: theme.spacing(1),
    },
    viewDetailsContainer: {
      display: 'flex',
      marginTop: theme.spacing(3),
      cursor: 'pointer',
    },
    viewEmptyDetailsContainer: {
      display: 'flex',
      marginTop: theme.spacing(0.5),
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'center',
    },
    viewDetailsText: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.select.light,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
  }
})
